import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuthStore } from '../../stores/authStore';
import { trpc } from '../../lib/api';

interface SharedUserGuardProps {
  children: React.ReactNode;
}

/**
 * 共有ユーザー専用のガードコンポーネント
 * 共有ユーザーでない場合は通常のAppレイアウトにリダイレクト
 */
export function SharedUserGuard({ children }: SharedUserGuardProps) {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();
  const [isSharedUser, setIsSharedUser] = useState<boolean | null>(null);

  const { data: profile, isLoading } = trpc.user.getProfile.useQuery(undefined, {
    enabled: isAuthenticated,
  });

  useEffect(() => {
    if (profile) {
      // userTypeがsharedかどうかチェック
      const userType =
        typeof profile === 'object' && 'userType' in profile
          ? (profile as { userType?: string | null }).userType
          : undefined;
      setIsSharedUser(userType === 'shared');
    }
  }, [profile]);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (isLoading || isSharedUser === null) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  // 共有ユーザーでない場合は通常のappにリダイレクト
  if (!isSharedUser) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <>{children}</>;
}
